// react
import React, {
  Fragment,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';

// styles
import styles from './index.module.scss';
// components
import { NavHeader } from '../../../components/navHeader';
import { Message } from '../../../components/message';
import { Seperator } from '../../../components/seperator';
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from './indexReducer';
// MUI
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// services
import { getStatisticsService } from '../../../services/adminService.js';
//  get role service
import { getRoleService } from '../../../services/adminService';
// cookies
import Cookies from 'js-cookie';
// router
import { useNavigate } from 'react-router-dom';

/***************************************************************************/
/* Name : StatisticsPage React Component */
/***************************************************************************/
const StatisticsPage = React.memo(() => {
  const navigate = useNavigate();
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  // number of students
  const [numberOfStudents, setNumberOfStudents] = useState(0);
  // number of students completed
  const [numberOfStudentsCompleted, setNumberOfStudentsCompleted] = useState(0);
  // facultiesStatistics
  const [facultiesStatistics, setFacultiesStatistics] = useState([]);
  // role state
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // get token
      let token = Cookies.get('token');
      if (!token) {
        // navigate to login
        navigate('/admin/login');
      }
      // get role
      const { role } = await getRoleService(token);
      if (role !== 'SUPERADMIN') {
        // navigate to login
        navigate('/admin/login');
      }
      // get statistics
      await getStatistics();
    })();
  }, []);
  /******************************************************************/
  /* getStatistics */
  /******************************************************************/
  const getStatistics = async () => {
    dispatchDashboardStates({ type: 'PENDING_LOADING' });
    const response = await getStatisticsService();
    if (response.status === 'success') {
      setNumberOfStudents(response.allStudentsNumber);
      setNumberOfStudentsCompleted(response.allStudentsNumberCompleted);
      setFacultiesStatistics(response.data);
      dispatchDashboardStates({
        type: 'CLEAR',
      });
    } else {
      dispatchDashboardStates({
        type: 'ERROR',
        errorMessage: response.message,
      });
    }
  };
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: 'CLEAR' });
  };

  return (
    <Fragment>
      <NavHeader title={'الاحصائيات'} />
      <br />
      <br />
      <div className={styles['title-container']}>
        <Seperator word='العدد الكلي' />
      </div>
      <div className={styles['students-container']}>
        <div className={styles['infos']}>
          <div className={styles['info']}>
            <h3>عدد كل الطلبة</h3>
            <p>{numberOfStudents}</p>
          </div>
          <div className={styles['info']}>
            <h3>عدد الطلبة اكملوا بيانتهم</h3>
            <p>{numberOfStudentsCompleted}</p>
          </div>
        </div>
      </div>
      <br />
      <div className={styles['title-container']}>
        <Seperator word='احصائيات الكليات' />
      </div>
      <div className={styles['students-container']}>
        {facultiesStatistics.map((faculty, index) => {
          return (
            <div className={styles['infos']} key={index}>
              <div className={styles['info']}>
                <div className={styles['title']}>{faculty.faculty}</div>
              </div>
              <div className={styles['info']}>
                <h3>عدد كل الطلبة</h3>
                <p>{faculty.studentsNumber}</p>
              </div>
              <div className={styles['info']}>
                <h3>عدد الطلبة اكملوا بيانتهم</h3>
                <p>{faculty.studentsNumberCompleted}</p>
              </div>
            </div>
          );
        })}
        {dashboardStates.pendingLoading && (
          <Message type={'load'} text={'يتم الان تحميل البيانات'} />
        )}
      </div>
      {facultiesStatistics.length === 0 && !dashboardStates.pendingLoading && (
        <Message type={'info'} text={'لا يوجد بيانات'} />
      )}
      {/* ********** SUCESS SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.success}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity='success'
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#388E3C',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          {dashboardStates.successMessage}!
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Alert
          severity='error'
          onClose={handleCloseSnackbar}
          dir='ltr'
          sx={{
            width: '100%',
            backgroundColor: '#D32F2F',
            color: '#fff',
            fontSize: '1.4rem',
            '& .MuiAlert-icon': {
              color: '#fff',
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StatisticsPage };
